import MenuCard from 'components/MenuCard/MenuCard.component';
import { ComponentProps } from 'react';
import media from 'style-utils/media-queries';
import styled, { StyledProps } from 'styled-components';

export const MenuCardOnRails = styled(MenuCard)`
  ${media.desktop`
    ${({ menuCard }: ComponentProps<StyledProps<typeof MenuCard>>): string => {
      if (menuCard?.smallCard) {
        return `
          grid-column: span 1;
         `;
      }

      return `
        grid-column: span 2;
       `;
    }}
 `}
`;
